import React from 'react';

import { useTagState, useTagActions } from './TagContext';
import { updateTag } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const UpdateTagForm = () => {
  const state = useTagState();
  const { onResponse, onError, updateTheUpdateTagForm } = useTagActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    updateTag({
      onResponse,
      onError,
      body: {
        authenticityToken,
        updateTagForm: state?.updateTagForm,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Tag Value" id="tagValue">
        <Input
          type="text"
          value={state?.updateTagForm?.value || ''}
          onChange={(e) => updateTheUpdateTagForm(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button type="submit">Update</Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default UpdateTagForm;
